import React from "react";
import { FileText, Download } from "lucide-react";

const SECTIONS = [
  {
    h: "1. Overview",
    p: "SuiPads is a fully on-chain, fair-launch memecoin launchpad on the Sui mainnet. Every coin launches on a bonding curve with no presale and no team allocation. When a coin's curve fills, liquidity migrates automatically to a Cetus AMM pool and the LP position is permanently locked. All core economics — pricing, fees and graduation — are enforced by the Move smart contract, not by a trusted operator.",
  },
  {
    h: "2. Token Supply & Bonding Curve",
    p: "Each coin mints a fixed 1,000,000,000 supply. 750,000,000 tokens (75%) are sold along the bonding curve, and 250,000,000 (25%) are reserved to seed the Cetus liquidity pool at graduation. Price on the curve follows a constant-product formula against a virtual SUI reserve, so the market cap starts meaningful and rises smoothly as buyers deposit SUI. Anyone can buy or sell against the curve instantly — no order book, no external liquidity required.",
  },
  {
    h: "3. Fees",
    p: "A flat 1% fee applies to every trade, split 70/30 on-chain: 0.7% accrues to the coin creator as a claimable dev reward, and 0.3% goes to the platform. Creator fees are never auto-sent — the creator claims them to their own wallet at any time directly from the contract.",
  },
  {
    h: "4. Graduation to Cetus",
    p: "When a curve collects 7,500 SUI, the coin graduates. The remaining curve tokens plus all collected SUI are deployed into a new SUI/<token> pool on Cetus, the LP is permanently locked so liquidity can never be rugged, and price continues seamlessly with no drop because the pool is seeded at exactly the curve's final price. Graduation runs automatically on a keeper schedule and completes even if the creator is offline.",
  },
  {
    h: "5. Vesting",
    p: "Creators and holders can voluntarily lock tokens in the on-chain vesting contract for 7, 30 or 60 days. Locked tokens are held by the contract and can only be returned to the original locker after the cliff — there is no admin or backdoor path to seize them. Dev locks are shown publicly on each coin to signal commitment.",
  },
  {
    h: "6. Referrals",
    p: "SuiPads runs a referral program that shares a portion of the platform fee with users who bring in trading volume. A referral is only credited after the referred trader signs a wallet message authorizing it, and payouts are released to the referrer's own wallet after a signed, single-use claim — so referral earnings cannot be spoofed or double-spent.",
  },
  {
    h: "7. Risk Disclaimer",
    p: "Memecoins are extremely high-risk, speculative assets and can lose all value. SuiPads is non-custodial infrastructure: you transact directly from your own Sui wallet and are solely responsible for your decisions. Nothing on this platform is financial advice.",
  },
];

export default function Whitepaper() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="whitepaper-page">
      <div className="flex items-center gap-2 mb-2">
        <FileText className="w-6 h-6 text-[#1EC62E]" />
        <h1 className="font-display font-extrabold text-4xl">White<span className="gradient-text">paper</span></h1>
      </div>
      <p className="text-muted-foreground mb-8">The SuiPads protocol — a fair-launch, fully on-chain memecoin launchpad on Sui.</p>
      <a href="/suipads-whitepaper.pdf" download data-testid="whitepaper-download" className="inline-flex items-center gap-2 mb-8 px-4 py-2.5 rounded-lg font-bold text-sm text-black transition-transform hover:scale-[1.02]" style={{ background: "linear-gradient(90deg,#1EC62E,#7CF24E)" }}>
        <Download className="w-4 h-4" /> Download PDF
      </a>
      <div className="space-y-4">
        {SECTIONS.map((s) => (
          <div key={s.h} className="card-surface p-5">
            <h2 className="font-display font-bold text-lg mb-1.5">{s.h}</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">{s.p}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
